/**
 * taskActionErrorMessage - the message to show when a task action is refused.
 *
 * Wave 3 made `complete` refuse a task that is staged OR carries a held action (409
 * `task_release_required`): those close with the Eingang's Gesamtfreigabe, never one by
 * one. The api answers that with a German sentence saying exactly where to close it, and
 * a flat "Aktion fehlgeschlagen." threw it away - leaving a broker with a task whose
 * Erledigen refuses and, for the three held actions that have no executor yet, whose
 * Freigabe refuses too, with no reason given for either.
 *
 * Only a 4xx carrying a `code` is trusted. That pair is what a deliberate refusal looks
 * like - the api saying "you cannot do that, here is why", in a sentence written for a
 * broker. A 5xx is a fault: its message describes what broke on our side, and a code on it
 * (`boom`, an internal literal) does not make it readable. A transport failure has neither.
 * Both fall back, because "Aktion fehlgeschlagen" is the honest thing to say about them.
 */
import { ApiError } from './api-client';

export function taskActionErrorMessage(err: unknown, fallback = 'Aktion fehlgeschlagen.'): string {
  const refusal =
    err instanceof ApiError && err.status >= 400 && err.status < 500 && Boolean(err.code);
  return refusal && err.message.trim() !== '' ? err.message : fallback;
}
